// LocalStorage key saves firebase cloud message token when the app registers to receive notifications
const FCM_TOKEN = 'fcmToken';

// LocalStorage key saves userId to check the case when the user is logged in, registers the token
// and the case does not register fcmToken when it is not needed
const FCM_USER_ID = 'fcmUserId';

const FCM_TRANSPORT = 'fcm';

// LocalStorage key saves fcm token registration status
const FCM_REGISTER_TOKEN_SUCCESS = 'fcmRegisterTokenSuccess';

// LocalStorage key saves uns app id
const UNS_APP_ID = 'fcmUNSAppId';

// Maximum notification items shown in the header bell popover
const NOTIFICATION_POPUP_PAGE_SIZE = 3;

// Number of notifications loaded per "load more" page in the full-list modal
const NOTIFICATION_MODAL_PAGE_SIZE = 20;

export default {
  FCM_TOKEN,
  FCM_USER_ID,
  FCM_TRANSPORT,
  FCM_REGISTER_TOKEN_SUCCESS,
  UNS_APP_ID,
  NOTIFICATION_POPUP_PAGE_SIZE,
  NOTIFICATION_MODAL_PAGE_SIZE,
};
